import { Injectable } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpEventType,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { redactSecrets } from 'common/redact'
import { CommService } from './comm.service'
import { DevTenantService } from './dev-tenant.service'

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private comm: CommService, private devTenant: DevTenantService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    this.comm.startTask()
    const tenant = this.devTenant.current()
    if (tenant) {
      req = req.clone({ setHeaders: { 'X-Dev-Tenant': tenant } })
    }
    // Never log a raw request or response: the login body carries the
    // password, the login result the JWT. Log the useful part with
    // secret-looking keys redacted. (The issue tracker no longer records
    // console output, see core/errors/issueTracker.ts; the browser console
    // is still no place for either.)
    console.log(`${req.method} ${req.urlWithParams}`, redactSecrets(req.body))
    return next.handle(req).pipe(
      tap(
        (res) => {
          if (res.type === HttpEventType.Response) {
            console.log(`${res.status} ${res.url}`, redactSecrets(res.body))
          } else if (res.type !== HttpEventType.Sent) {
            console.log(res)
          }
        },
        (err) => {
          this.comm.finishTask()
        }, // global error handler takes care of logging errors
        () => {
          this.comm.finishTask()
        },
      ),
    )
  }
}
